const styles = ({ COLORS }) => ({
  link: {
    margin: '0 6px',
    paddingBottom: '16px',
    fontSize: '16px',
    position: 'relative',
    fontWeight: 'bold',
    '& > a': {
      textDecoration: 'none',
      color: '#777',
      transition: 'color 0.3s ease-in-out'
    },
    '&:hover > a': {
      color: COLORS.BLUE.NORMAL
    }
  },
  activeLink: {
    '& > a': {
      color: COLORS.BLUE.NORMAL
    }
  }
})

export default styles
